"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const msal_react_1 = require("@azure/msal-react");
const react_router_dom_1 = require("react-router-dom");
const Msal_1 = require("@/Msal");
const index_view_1 = __importDefault(require("./index.view"));
function Header() {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const { user } = (0, Msal_1.useAuthContext)();
    const { instance } = (0, msal_react_1.useMsal)();
    const pickTab = () => {
        if (location.pathname === "/") {
            return 0;
        }
        if (location.pathname.includes("/approved-feedstock")) {
            return 1;
        }
        if (location.pathname.includes("/products")) {
            return 2;
        }
        if (location.pathname.includes("/sites-and-systems")) {
            return 3;
        }
        if (location.pathname.includes("/ports")) {
            return 4;
        }
        if (location.pathname.includes("/other-costs")) {
            return 5;
        }
        if (location.pathname.includes("/evaluators")) {
            return 6;
        }
        return 0;
    };
    const [currentTab, selectTab] = (0, react_1.useState)(pickTab());
    (0, react_1.useEffect)(() => {
        const currentTab = pickTab();
        selectTab(currentTab);
    }, [location.pathname]);
    const onChangeTab = (0, react_1.useCallback)((event, newTab) => {
        selectTab(newTab);
    }, [selectTab]);
    const tabsOptions = (0, react_1.useMemo)(() => {
        return [
            { label: "Components", to: "/" },
            { label: "Approved Feedstock", to: "/approved-feedstock" },
            { label: "Products", to: "/products" },
            { label: "Sites", to: "/sites-and-systems" },
            { label: "Ports", to: "/ports" },
            { label: "Evaluators", to: "/evaluators" },
            { label: "Other Costs", to: "/other-costs" },
        ];
    }, []);
    const onLogout = (0, react_1.useCallback)(() => {
        instance.logout();
        localStorage.clear();
    }, [instance]);
    const onGoToUsers = (0, react_1.useCallback)(() => {
        history.push("/users");
    }, [history]);
    const accountMenuOptions = [
        { label: "Log out", onClick: onLogout },
        { label: "Register Users", onClick: onGoToUsers },
    ];
    return (react_1.default.createElement(index_view_1.default, { userEmail: user?.username, onChangeTab: onChangeTab, currentTab: currentTab, tabsOptions: tabsOptions, accountMenuOptions: accountMenuOptions }));
}
exports.default = Header;
